import React from 'react';
import './Footer.css';

const Footer = () => {
    const email = "stauvron@ensc.fr";

    return (
        <footer className="footer">
            <div className="icons">
                <a href={`mailto:${email}`}>
                    <img src="/images/email.png" alt="Email Icon" className="icon" />
                </a>
                <a href="https://www.linkedin.com/in/simon-tauvron-2a45b2243/" target="_blank" rel="noopener noreferrer">
                    <img src="/images/linkedin.png" alt="LinkedIn Icon" className="icon" />
                </a>
            </div>
            <p className="footer-text">Copyright © 2024 Simon Tauvron. Inspired by Lee Namju. All Rights Reserved.</p>
        </footer>
    );
};

export default Footer;
